import axios from "axios";
import { API_BASE_URL } from "../constants";

// Existing function (keep this)
export const trackCasinoInsight = async ({ casinoId, page, type }) => {
  try {
    const res = await axios.post(`${API_BASE_URL}api/casino-insights/track`, {
      casinoId,
      page,
      type,
    });
    return res.data;
  } catch (err) {
    console.error("❌ Insight track failed:", err?.response?.data || err.message);
  }
};

export const getTopCasinoInsights = async (params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_BASE_URL}api/casino-insights/top-casinos${queryString ? `?${queryString}` : ""}`;

    const res = await axios.get(url);
    return res.data?.data || [];
  } catch (err) {
    console.error("❌ Failed to fetch top casino insights:", err?.response?.data || err.message);
    return [];
  }
};

